import type { Selection } from "../types";

export function selectionEquals(a: Selection, b: Selection): boolean {
  if (a.kind !== b.kind) {
    return false;
  }
  if (a.kind === 'email' && b.kind === 'email') {
    return true;
  }
  if (a.kind === 'group' && b.kind === 'group') {
    return a.groupId === b.groupId;
  }
  if (a.kind === 'row' && b.kind === 'row') {
    return a.rowId === b.rowId;
  }
  if (a.kind === 'column' && b.kind === 'column') {
    return a.rowId === b.rowId && a.columnId === b.columnId;
  }
  if (a.kind === 'block' && b.kind === 'block') {
    return (
      a.rowId === b.rowId &&
      a.columnId === b.columnId &&
      a.blockId === b.blockId
    );
  }
  if (a.kind === 'buttonRowSlot' && b.kind === 'buttonRowSlot') {
    return (
      a.rowId === b.rowId &&
      a.columnId === b.columnId &&
      a.blockId === b.blockId &&
      a.slotIndex === b.slotIndex
    );
  }
  return false;
}
